import { ButtonGroup, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { add } from 'date-fns';
import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { theme } from '../../../theme/theme';
import { Button } from '../../global';
import '../cards/BarChartCard';
import { BarChartCard } from '../cards/BarChartCard';

const useStatusProgressionClasses = makeStyles({
    buttons: {
        alignSelf: 'center',
        boxShadow: 'none',
        '& > button': {
            padding: '5px 15px',
        },
        '& > button:not(.selected)': {
            background: `${theme.colors.neutral[9]} !important`,
            color: `${theme.colors.darkBlue[5]} !important`,
        },
        '& > button:first-child': {
            borderRadius: '18px 0 0 18px',
        },
        '& > button:last-child': {
            borderRadius: '0 18px 18px 0',
        },
    },
});

/**
 * Fetch project status progression information and render it using a bar chart card.
 */
export const StatusProgression = () => {
    const classes = useStatusProgressionClasses();
    const { t } = usePrefixTranslation('dashboard', { dashboard: 'metrics.StatusProgression' });
    const dispatch = useTypedDispatch();
    const { statusProgression } = useTypedSelector(state => ({ statusProgression: state.stats.statusProgression }));
    const [view, setView] = React.useState<'month' | 'quarter' | 'year'>('month');
    const colors = { inspect: ['#3F2B96', '#A8C0FF'], report: ['#A18CD1', '#FBC2EB'], review: ['#FF9A9E', '#FAD0C4'] };
    const data = Object.entries(statusProgression.stats ?? {}).map(([name, time]) => {
        return {
            color: (colors as any)[name],
            name: t(`label-${name}`),
            main: t('hours', { count: time }),
            value: time,
        };
    });

    React.useEffect(() => {
        const interval = {
            start: add(new Date(), {
                months: view === 'month' ? -1 : view === 'quarter' ? -3 : 0,
                years: view === 'year' ? -1 : 0,
            }),
            end: new Date(),
        };
        dispatch(actions.stats.statusProgression(interval));
    }, [view]);

    const buttons = (
        <ButtonGroup className={classes.buttons} variant='contained' size='small'>
            {(['month', 'quarter', 'year'] as const).map(buttonView => {
                const cls = { selected: buttonView === view };
                return (
                    <Button key={buttonView} className={clsx(cls)} onClick={() => setView(buttonView)}>
                        {t(`button-${buttonView}`)}
                    </Button>
                );
            })}
        </ButtonGroup>
    );

    return (
        <BarChartCard
            fetching={statusProgression.fetching && !statusProgression.stats}
            name={t('title')}
            data={data}
            footer={buttons}
        />
    );
};
